<template>
  <div class="goods-info">
    <div class="search">
      <div class="search-left">
        <el-select v-model="customerId" class="gray" placeholder="请选择货主" clearable>
          <el-option
            v-for="item in customerList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          class="gray"
          v-model="name"
          placeholder="请输入商品名称/条码/编码"
          clearable
        ></el-input>
        <el-button class="btn-blue" @click="searchData">搜索</el-button>
      </div>
      <div class="search-left">
        <el-button class="btn-blue" @click="commodityImport"
          >商品导入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
    <!-- 商品导入 -->
    <el-dialog
      title="商品导入"
      top="35vh"
      :visible.sync="dialog"
      width="360px"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="货主：" prop="customerId">
          <el-select v-model="form.customerId" class="gray" placeholder="请选择">
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            :disabled="form.customerId ? false : true"
            v-loading.fullscreen.lock="loading"
            element-loading-text="文件上传中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            class="upload"
            ref="upload"
            action="#"
            :show-file-list="false"
            :auto-upload="true"
            :before-upload="uploadGoodsInfoExcel"
          >
            <el-button slot="trigger" type="text" class="btn-text" @click="clickUpload">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import GoodsInfo from "models/goods-info";
import Logistics from "models/logistics";
const logistics = new Logistics();
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '货主名称', prop: 'customerName', width: '200'},
        {label: '商品编码', prop: 'code', width: '120'},
        {label: '条码', prop: 'barCode', width: '120'},
        {label: '商品名称', prop: 'goodsName', width: '240'},
        {label: '商品规格', prop: 'goodsSpecifications', width: '240'},
      ],
      customerId: '',
      customerList: [],
      name: "",
      dialog: false,
      loading: false,
      form: {
        customerId: null,
      }
    };
  },

  created() {
    this.initGoodsInfoList();
    this.initCustomerList()
  },

  methods: {
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initGoodsInfoList();
    },
    initGoodsInfoList() {
      let pageNo = this.currentPage
      let customerId = this.customerId
      let queryStrValue = this.name
      GoodsInfo.getGoodsInfo(pageNo,customerId,queryStrValue).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.customerId = i.customerId
            obj.customerName = i.customerName
            obj.code = i.goodsCode
            obj.barCode = i.barCode
            obj.goodsName = i.goodsName
            obj.goodsSpecifications = i.goodsSpec
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 获取货主名称 */
    initCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    searchData() {
      this.currentPage = 1;
      this.initGoodsInfoList();
    },
    commodityImport() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    clickUpload() {
      if (!this.form.customerId) {
        this.$message.error("请选择货主");
      }
    },
    uploadGoodsInfoExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("customerId", this.form.customerId);
      this.loading = true;
      GoodsInfo
        .postUploadGoodsInfoExcel(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.initGoodsInfoList();
            this.loading = false;
            this.closeDialog()
          } else {
            this.loading = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          this.$message.error("导入失败");
          this.loading = false;
        });
      return false;
    },
    confirm() {
      this.closeDialog()
    }
  },
};
</script>

<style lang='scss' scoped>
.goods-info {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-select {
      margin-right: 16px;
    }
    .el-input {
      width: 200px;
    }
    .btn-blue {
      margin-left: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<style lang="scss">
.goods-info {
  .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .el-dialog__body {
      display: flex;
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
